const PLAYGROUND_ORIGIN = 'https://cwr.alvdev.com/'
// local: 'http://localhost:9000'

const CWR_PREVIEW_EXTENSIONS = ['.v21', '.v22', '.cwr', '.ack']

export function isCwrPreviewableFile(pathOrName) {
    if (!pathOrName) return false
    const withoutQuery = String(pathOrName).split('?')[0]
    const base = withoutQuery.split(/[/\\]/).pop() || ''
    const lower = base.toLowerCase()
    return CWR_PREVIEW_EXTENSIONS.some(ext => lower.endsWith(ext))
}

export function openCwrPreview(downloadUrl) {
    if (!downloadUrl) return
    window.open(
        `${PLAYGROUND_ORIGIN}/?url=${encodeURIComponent(downloadUrl)}`,
        '_blank',
        'noopener,noreferrer'
    )
}

export function openAckPreview(downloadUrl) {
    if (!downloadUrl) return
    window.open(
        `${PLAYGROUND_ORIGIN}/?file=${encodeURIComponent(downloadUrl)}`,
        '_blank',
        'noopener,noreferrer'
    )
}
